import { Link } from "react-router-dom";
import EmberButton from "@/components/EmberButton";

export default function NotFoundPage() {
    return (
        <section className="section" data-testid="not-found-page">
            <div className="container-narrow text-center">
                <div className="font-display text-7xl text-white">404</div>
                <p className="mt-2 text-white/70">This trail leads to ash. Let&rsquo;s get you back to the pit.</p>
                <EmberButton to="/" className="mt-6 inline-block">Back Home</EmberButton>
            </div>
        </section>
    );
}
